import { useMemo } from 'react'
import { useColorTheme } from '../contexts/ColorThemeContext'

export const useThemeColors = () => {
  const { palette } = useColorTheme()
  
  const colors = useMemo(() => ({
    // Gradients
    heroGradient: `linear-gradient(135deg, ${palette.colors.primary} 0%, ${palette.colors.primaryLight} 50%, ${palette.colors.secondary} 100%)`,
    ctaGradient: `linear-gradient(135deg, ${palette.colors.primary} 0%, ${palette.colors.primaryLight} 50%, ${palette.colors.secondary} 100%)`,
    
    // Primary colors
    primary: palette.colors.primary,
    primaryLight: palette.colors.primaryLight,
    primaryDark: palette.colors.primaryDark,
    
    // Secondary colors
    secondary: palette.colors.secondary,
    secondaryLight: palette.colors.secondaryLight,
    secondaryDark: palette.colors.secondaryDark,
    
    // Accent colors
    accent: palette.colors.accent,
    accentLight: palette.colors.accentLight,
    accentDark: palette.colors.accentDark,
    
    // Background colors
    background: palette.colors.background,
    surface: palette.colors.surface,
    surfaceLight: palette.colors.surfaceLight,
    
    // Text colors
    textPrimary: palette.colors.textPrimary,
    textSecondary: palette.colors.textSecondary,
    textInverse: palette.colors.textInverse,
    
    // UI colors
    success: palette.colors.success,
    successLight: palette.colors.successLight,
    successDark: palette.colors.successDark,
    warning: palette.colors.warning,
    warningLight: palette.colors.warningLight,
    warningDark: palette.colors.warningDark,
    error: palette.colors.error,
    errorLight: palette.colors.errorLight,
    errorDark: palette.colors.errorDark,
    info: palette.colors.info,
    infoLight: palette.colors.infoLight,
    infoDark: palette.colors.infoDark,
    
    // Border colors
    border: palette.colors.border,
    borderLight: palette.colors.borderLight,
    borderStrong: palette.colors.borderStrong,
    
    // Transparent variants
    primaryAlpha10: `${palette.colors.primary}1A`,
    primaryAlpha20: `${palette.colors.primary}33`,
    primaryAlpha30: `${palette.colors.primary}4D`,
    secondaryAlpha10: `${palette.colors.secondary}1A`,
    secondaryAlpha20: `${palette.colors.secondary}33`,
  }), [palette])
  
  return colors
}